import { MotivoPerdaVenda } from '../../motivo-perda-venda';

/** Utilizada para atualizar o status projetado das projeções de vendas mensais do cliente */
export class ClienteAnaliseMercadoProjecaoUpdateStatus {
    /** ID do cliente a ser atualizadas as projeções de vendas */
    idCliente: number;
    /** Mês das projeções de vendas */
    mes: number;
    /** Ano das projeções de vendas */
    ano: number;
    /** Status atual das projeções do cliente */
    statusProjetadoAtual: number;
    /** Etapa da Negociação atual das projeções do cliente */
    idEtapaNegociacaoProjecaoAtual: number;

    /** Status para qual deve ser alterado */
    statusProjetado: number;
    // Status = Projetado
    /** Quantidade projetada quando alterado para Projetado */
    quantidadeProjetada: number;
    /** Peso projetado quando alterado para Projetado */
    pesoProjetado: number;
    /** Valor projetado quando alterado para Projetado */
    valorProjetado: number;
    // Status = Em Negociação
    /** Etapa da Negociação quando alterado para Em Negociação */
    idEtapaNegociacaoProjecao: number;
    // Status = Perdido
    /** ID do Motivo da Perda quando alterado para Perdido */
    idMotivoPerdaProjetado: number;
    /** Motivo da Perda quando alterado para Perdido */
    motivoPerdaProjetado: MotivoPerdaVenda;
    /** Justificativa da Perda quando alterado para Perdido */
    justificativaPerdaProjetado: string;

    /**
     * Cria um novo update para atualizar o status projetado das projeções de vendas mensais do cliente
     *
     * @param idCliente ID do cliente
     * @param mes mês das projeções
     * @param ano ano das projeções
     * @param statusProjetadoAtual status projetado atual das projeções do cliente
     * @param idEtapaNegociacaoProjecaoAtual etapa de negociação atual das projeções do cliente quando estiver Em Negociação
     * @param statusProjetado status para qual deve ser alterado
     */
    constructor(idCliente: number, mes: number, ano: number, statusProjetadoAtual: number, idEtapaNegociacaoProjecaoAtual: number, statusProjetado: number) {
        this.idCliente = idCliente;
        this.mes = mes;
        this.ano = ano;
        this.statusProjetadoAtual = statusProjetadoAtual;
        this.idEtapaNegociacaoProjecaoAtual = idEtapaNegociacaoProjecaoAtual;
        this.statusProjetado = statusProjetado;
    }
}
